import { useState, useEffect } from 'react';
import { ChatProfile, ChatMessageList, ChatForm } from '../../molecules';
import { useChat } from '../../../hooks';

const Chat = ({ currentChat, index }) => {
  const [message, setMessage] = useState("");

  const { messages, loading, sendMessage } = useChat(currentChat, index);

  const onSubmit = async () => {
    if (message.trim() === "") return;
    await sendMessage(message);
    setMessage("");
  }

  const onChangeInputValue = (name, value) => {
    setMessage(value);
  }

  return (
    <div className="chat">
      <ChatProfile nome={currentChat.nome} photo_url={currentChat.photo_url} stage={currentChat.stage} />
      <ChatMessageList loading={loading} messages={messages} />
      <ChatForm onChangeInputValue={onChangeInputValue} value={message} onSubmit={onSubmit} />
    </div>
  );
}

export { Chat };
